/* eslint-disable max-len */
import React, { FC, useEffect, useState } from "react";
import {
    Box,
    Card,
    CardActionArea,
    CardMedia,
    CardContent,
    Grid,
    Typography,
    useTheme,
    useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getImageUrl } from "utils/imageUtils";
import Country from "models/Country";
import countryService from "services/countryService";

const TopCountries: FC = () => {
    const navigate = useNavigate();
    const [countries, setCountries] = useState<Country[]>([]);
    const [loading, setLoading] = useState(true);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    useEffect(() => {
        const fetchCountries = async () => {
            try {
                setLoading(true);
                const res = await countryService.getSuggestions();
                setCountries(res.slice(0, 3));
            } catch {
            } finally {
                setLoading(false);
            }
        };
        fetchCountries();
    }, []);

    if (loading) return <div />;

    return (
        <Box sx={{ py: 6, px: { xs: 2, sm: 4, md: 8 } }}>
            <Typography
                variant="h5"
                fontWeight={600}
                mb={3}
                textAlign="center"
                sx={{ fontSize: { xs: "1.3rem", md: "1.7rem" } }}
            >
                Destinations les plus populaires
            </Typography>

            <Grid
                container
                spacing={isMobile ? 2 : 4}
                justifyContent="center"
                alignItems="stretch"
            >
                {countries.map((country) => {
                    const picture = country.brief?.destinationBriefPictures?.[0];
                    const imageUrl = picture ? getImageUrl(picture.url) : "";

                    return (
                        <Grid
                            item
                            xs={12}
                            sm={10}
                            md={4}
                            lg={3.5}
                            key={country.id}
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <Card
                                sx={{
                                    borderRadius: 3,
                                    overflow: "hidden",
                                    boxShadow: 4,
                                    width: "100%",
                                    maxWidth: isMobile ? "100%" : 420, // largeur max sur desktop
                                    transition: "transform 0.25s ease",
                                    "&:hover": { transform: "scale(1.03)" },
                                }}
                            >
                                <CardActionArea onClick={() => navigate(`/fiche-pays/${country.id}`)}>
                                    <CardMedia
                                        component="img"
                                        image={imageUrl}
                                        alt={country.name}
                                        sx={{
                                            height: isMobile ? 200 : 280,
                                            objectFit: "cover",
                                        }}
                                    />
                                    <CardContent
                                        sx={{
                                            textAlign: "center",
                                            backgroundColor: "#f8fafc",
                                            py: 2,
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            fontWeight={600}
                                            sx={{ fontSize: { xs: "1.1rem", md: "1.25rem" } }}
                                        >
                                            {country.name}
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
};

export default TopCountries;
